import { Auth } from 'aws-amplify'
export async function awsLogin(payload) {
    try {
        const postBack = await Auth.signIn(payload.data.email, payload.data.password)
        return await postBack
    } catch (err) {
        throw err
    }
}
export async function awsLogout() {
    try {
        const postBack = await Auth.signOut()
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsRefresh() {
    try {
        const cognitoUser = await Auth.currentAuthenticatedUser()
        const currentSession = await Auth.currentSession()
        await new Promise((resolve, reject) => {
            cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
                if (err) reject(err)
                else resolve(session)
            })
        })
        return await Auth.currentAuthenticatedUser()
    } catch (err) {
        throw err
    }
}

export async function awsConfirmSignUp(payload) {
    try {
        const postBack = await Auth.confirmSignUp(payload.email, payload.authenticationCode)
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsSignUp(payload) {
    try {
        const postBack = await Auth.signUp(payload)
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsForgotPassword(payload) {
    try {
        const postBack = await Auth.forgotPasswordSubmit(payload.email, payload.code, payload.password)
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsResetPassword(payload) {
    try {
        const postBack = await Auth.forgotPassword(payload.email)
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsResendConfirmation(payload) {
    try {
        const postBack = await Auth.resendSignUp(payload.email)
        return await postBack
    } catch (err) {
        throw err
    }
}

export async function awsIsValidSession() {
    try {
        const user = await Auth.currentAuthenticatedUser()
        if (!user) return false
        return true
    } catch (err) {
        return false
    }
}

export async function awsUpdateUserAttributes(attributes) {
    let user = await Auth.currentAuthenticatedUser()

    return await Auth.updateUserAttributes(user, attributes)
}

const mask = s => s.replace(/^(\+\d{2}).+(\d{4})$/, '$1****$2')
export async function savePhoneAndSendCode(e164) {
    const user = await Auth.currentAuthenticatedUser()

    await Auth.updateUserAttributes(user, { phone_number: e164 }) // "SUCCESS"
    await Auth.verifyCurrentUserAttribute('phone_number') // "SUCCESS" (sends/resends)

    return { status: 'CODE_SENT', destination: mask(e164) }
}

export async function confirmPhone(code) {
    await Auth.verifyCurrentUserAttributeSubmit('phone_number', code)
    const fresh = await Auth.currentAuthenticatedUser({ bypassCache: true })
    // optional: check verified flag
    const attrs = await Auth.userAttributes(fresh)
    const verified = attrs.find(a => a.Name === 'phone_number_verified')?.Value === 'true'
    return { status: verified ? 'VERIFIED' : 'PENDING' }
}
